import Button from 'UIKit/Button'
import IconButton from 'UIKit/Button/IconButton'
import Popper from 'UIKit/Popper'
import { InhouseGameDetails } from 'config/types/game'
import useToggle from 'hooks/useToggle'
import Column from 'layout/Components/Column'
import styled from 'styled-components'
import { Icons } from 'svgs'
import colors from 'theme/ui/colors'
import { GameInHouseConfig } from 'views/InhouseGame/config/types'
import HotKeyControl from './HotKeyControl'
import InstanceBetControl from './InstanceBetControl'
import VolumeControls from './VolumeControls'

const GraphicSettingsDropdown: React.FC<
  GameInHouseConfig & {
    onUpdateConfig?: (key: GameInHouseConfig) => void
    game?: InhouseGameDetails
  }
> = ({ game, volumeEnable = true, instanceBetEnable = false, hotkeyEnable = false, onUpdateConfig }) => {
  return (
    <StyledWrapContentDropdown>
      <VolumeControls
        value={volumeEnable}
        onChangeSetting={(value) =>
          onUpdateConfig({
            volumeEnable: value,
          })
        }
      />
      <InstanceBetControl
        value={instanceBetEnable}
        onChangeSetting={(value) =>
          onUpdateConfig({
            instanceBetEnable: value,
          })
        }
      />
      {/* <MaxBetButtonControl
        value={maxBetButtonEnable}
        onChangeSetting={(value) =>
          onUpdateConfig({
            maxBetButtonEnable: value,
          })
        }
      /> */}
      <HotKeyControl
        value={hotkeyEnable}
        game={game}
        onChangeSetting={(value) =>
          onUpdateConfig({
            hotkeyEnable: value,
          })
        }
      />
    </StyledWrapContentDropdown>
  )
}

const GraphicSettings: React.FC<{ size: string; game?: InhouseGameDetails } & GameInHouseConfig> = ({
  size,
  game,
  ...props
}) => {
  const [toggle, setToggle] = useToggle(false)

  return (
    <IconButton>
      <Popper
        open={toggle}
        setOpen={setToggle}
        dropdownPosition={'top-left'}
        dropdownContent={<GraphicSettingsDropdown {...props} game={game} />}
      >
        <StyledButton variant="text" width="fit-content!important" height="fit-content !important" px="0px !important">
          <Icons.SettingOutLineIcon fill={colors.textSubtle} width={size} height={size} />
        </StyledButton>
      </Popper>
    </IconButton>
  )
}

const StyledButton = styled(Button)`
  &:hover {
    svg {
      fill: ${({ theme }) => theme.colors.text};
    }
  }
`
const StyledWrapContentDropdown = styled(Column)`
  padding: 8px;

  width: 160px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.bg_surface};
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 99%;
    left: 9%;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.5em 0.5em 0;
    border-color: ${({ theme }) => theme.colors.bg_surface} transparent transparent transparent;
    transform: translate(-50%);
    display: none;
    z-index: 1;
  }

  transform: translateX(-10%);

  ${({ theme }) => theme.mediaQueries.sm} {
    transform: unset;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    &:after {
      display: block;
    }
  }
`

export default GraphicSettings
